import { Props as DSCheckboxProps } from "@clockwise/design-system/src/components/Checkbox";
import { FormControlLabel, Checkbox as MuiCheckbox } from "@material-ui/core";
import React from "react";

type Color = string;
type Props = DSCheckboxProps & {
  color: Color;
};

/**
 * Extends the Design System checkbox interface, adding adds a color prop.
 * To support color; this component uses the MUI Checkbox component, which does support custom colors
 * When/if DS Checkbox adds support for colors; this component should be deprecated
 *
 * note: sentiment not supported
 * */
export const ColorCheckbox = (props: Props) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.onChange?.(event.target.checked);
  };

  return (
    <FormControlLabel
      control={
        <MuiCheckbox
          checked={props.checked}
          style={{
            color: props.color,
            padding: "0px 8px",
          }}
          onChange={handleChange}
          onClick={props.onClick}
          disabled={props.disabled}
          size={props.size}
          indeterminate={props.indeterminate}
          disableRipple
        />
      }
      labelPlacement={props.labelPlacement}
      label={props.label}
    />
  );
};
